import type { ApiMiddleware, ApiRequest, ApiRequestType } from '../types';

import { middleware as authorizationMiddleware } from './authorization';

const requestMiddlewares: Record<ApiRequestType, ApiMiddleware[]> = {
  Ecs: [],
  Graphql: [authorizationMiddleware],
  LegacyYammer: [authorizationMiddleware],
  SharePoint: [authorizationMiddleware],
  Ocv: [],
  Substrate: [authorizationMiddleware],
  ThirdParty: [],
  O365Shell: [authorizationMiddleware],
};

const addedMiddlewares: ApiMiddleware[] = [];

// Appends middleware to end of middleware chain.
// This method should be used only during bootstrap to minimize interfering with Redux state.
// Use only if the middleware has a dependency outside of `yammer-data`.
type AddMiddleware = (middleware: ApiMiddleware) => void;
export const addMiddleware: AddMiddleware = (middleware) => {
  addedMiddlewares.push(middleware);
};

type ApplyMiddleware = (apiRequest: ApiRequest) => Promise<ApiRequest>;
export const applyMiddleware: ApplyMiddleware = (apiRequest) => {
  const { requestType } = apiRequest;
  const middlewares = [...requestMiddlewares[requestType], ...addedMiddlewares];

  return middlewares.reduce(async (memo, middleware) => middleware(await memo), Promise.resolve(apiRequest));
};
